import {Component, OnInit} from '@angular/core';
import {PublicService} from '../public.service';
import {Router, NavigationEnd} from '@angular/router';

// import { DataService } from "../data.service";


@Component({
  selector: 'app-waste-list',
  templateUrl: './waste-list.component.html',
  styleUrls: ['./waste-list.component.scss']
})
export class WasteListComponent implements OnInit {
  // array : any = [];
  plasticStatus = false;
  breadStatus = false;

  constructor(public publicservice: PublicService, public router: Router) {
    // if (publicservice.logedIn == "false" || this.publicservice.logedIn == null) {
    //   this.router.navigate(['login']);
    // }


    this.publicservice.location = localStorage.getItem("location")!;
  }

  ngOnInit(): void {
  }

  addPlasticClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'پلاستیکی');
    if (sessionStorage.getItem('plasticStatus') != 'true') {
      sessionStorage.setItem('helpPlasticCounter', '1');
      sessionStorage.setItem('plasticMaxPrice', '3000');
    }
    sessionStorage.setItem('plasticStatus', 'true');

    // sessionStorage.setItem('helpPlasticCounter', '1');
  }

  addBreadClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'نان خشک');
    if (sessionStorage.getItem('breadStatus') != 'true') {
      sessionStorage.setItem('helpBreadCounter', '1');
      sessionStorage.setItem('breadMaxPrice', '1600');
    }
    sessionStorage.setItem('breadStatus', 'true');
  }

  addCpuClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'الکترونیکی');
    if (sessionStorage.getItem('cpuStatus') != 'true') {
      sessionStorage.setItem('helpCpuCounter', '1');
      sessionStorage.setItem('cpuMaxPrice', '35000');
    }
    sessionStorage.setItem('cpuStatus', 'true');
  }

  addPaperClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'کارتن و کاغذ');
    if (sessionStorage.getItem('paperStatus') != 'true') {
      sessionStorage.setItem('helpPaperCounter', '1');
      sessionStorage.setItem('paperMaxPrice', '1750');
    }
    sessionStorage.setItem('paperStatus', 'true');
  }

  addCannedFoodClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'حلبی');
    if (sessionStorage.getItem('canStatus') != 'true') {
      sessionStorage.setItem('helpCanCounter', '1');
      sessionStorage.setItem('canMaxPrice', '3800');
    }
    sessionStorage.setItem('canStatus', 'true');
  }

  addRiceClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'برنج');
    if (sessionStorage.getItem('riceStatus') != 'true') {
      sessionStorage.setItem('helpRiceCounter', '1');
      sessionStorage.setItem('riceMaxPrice', '70000');
    }
    sessionStorage.setItem('riceStatus', 'true');
  }

  addDryWasteClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'مخلوط خشک');
    if (sessionStorage.getItem('dryStatus') != 'true') {
      sessionStorage.setItem('helpDryCounter', '1');
      sessionStorage.setItem('dryMaxPrice', '22000');
    }
    sessionStorage.setItem('dryStatus', 'true');
  }

  addBottleClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'شیشه ای');
    if (sessionStorage.getItem('bottleStatus') != 'true') {
      sessionStorage.setItem('helpBottleCounter', '1');
      sessionStorage.setItem('bottleMaxPrice', '180');
    }
    sessionStorage.setItem('bottleStatus', 'true');
  }

  addShoesClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'قوطی');
    if (sessionStorage.getItem('shoesStatus') != 'true') {
      sessionStorage.setItem('helpShoesCounter', '1');
      sessionStorage.setItem('shoesMaxPrice', '12000');
    }
    sessionStorage.setItem('shoesStatus', 'true');
  }

  addIronClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'آهن');
    if (sessionStorage.getItem('ironStatus') != 'true') {
      sessionStorage.setItem('helpIronCounter', '1');
      sessionStorage.setItem('ironMaxPrice', '5100');
    }
    sessionStorage.setItem('ironStatus', 'true');
  }

  addMesClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'مس');
    if (sessionStorage.getItem('mesStatus') != 'true') {
      sessionStorage.setItem('helpMesCounter', '1');
      sessionStorage.setItem('mesMaxPrice', '80000');
    }
    sessionStorage.setItem('mesStatus', 'true');
  }

  addChodanClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'چدن');
    if (sessionStorage.getItem('chodanStatus') != 'true') {
      sessionStorage.setItem('helpChodanCounter', '1');
      sessionStorage.setItem('chodanMaxPrice', '35000');
    }
    sessionStorage.setItem('chodanStatus', 'true');
  }

  addPetClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'PET');
    if (sessionStorage.getItem('petStatus') != 'true') {
      sessionStorage.setItem('helpPetCounter', '1');
      sessionStorage.setItem('petMaxPrice', '2500');
    }
    sessionStorage.setItem('petStatus', 'true');
  }

  addBasketClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'سبد');
    if (sessionStorage.getItem('basketStatus') != 'true') {
      sessionStorage.setItem('helpBasketCounter', '1');
      sessionStorage.setItem('basketMaxPrice', '3000');
    }
    sessionStorage.setItem('basketStatus', 'true');
  }

  addLakClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'لاک');
    if (sessionStorage.getItem('lakStatus') != 'true') {
      sessionStorage.setItem('helpLakCounter', '1');
      sessionStorage.setItem('lakMaxPrice', '2500');
    }
    sessionStorage.setItem('lakStatus', 'true');
  }

  addAlSabokClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'آلومینیوم سبک');
    if (sessionStorage.getItem('alSabokStatus') != 'true') {
      sessionStorage.setItem('helpAlSabokCounter', '1');
      sessionStorage.setItem('alSabokMaxPrice', '13000');
    }
    sessionStorage.setItem('alSabokStatus', 'true');
  }

  addAlSanginClick() {
    this.router.navigate(['selected-items']);
    sessionStorage.setItem('ProductName', 'آلومینیوم سنگین');
    if (sessionStorage.getItem('alSanginStatus') != 'true') {
      sessionStorage.setItem('helpAlSanginCounter', '1');
      sessionStorage.setItem('alSanginMaxPrice', '15000');
    }
    sessionStorage.setItem('alSanginStatus', 'true');
  }

  backmap() {
    this.router.navigate(['get-location']);
  }
}
